var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            { staticClass: "order-info-tab" },
            [
              _c(
                "el-tabs",
                {
                  on: { "tab-click": _vm.changeTab },
                  model: {
                    value: _vm.activeName,
                    callback: function ($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName",
                  },
                },
                [
                  _c("el-tab-pane", {
                    attrs: { label: "订单信息", name: "1" },
                  }),
                  _c("el-tab-pane", {
                    attrs: { label: "订单规则", name: "4" },
                  }),
                  _c("el-tab-pane", {
                    attrs: { label: "售卡风险校验", name: "9" },
                  }),
                  _c("el-tab-pane", {
                    attrs: { label: "客户配置", name: "3" },
                  }),
                  _c("el-tab-pane", { attrs: { label: "日志", name: "2" } }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.activeName === "1"
            ? _c(
                "el-row",
                { staticClass: "my-row", attrs: { gutter: 20 } },
                _vm._l(_vm.orderInfoList, function (col) {
                  return _c("el-col", { key: col.value, attrs: { span: 4 } }, [
                    _c(
                      "div",
                      { staticClass: "content" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "label",
                            style: Object.assign({}, col.label_style || {}),
                          },
                          [_vm._v(" " + _vm._s(col.label) + " ")]
                        ),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              disabled: !col.tooltip,
                              content: String(
                                col.formatter
                                  ? col.formatter()
                                  : _vm.orderInfo[col.value]
                              ),
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "value",
                                style: Object.assign({}, col.style || {}),
                                on: {
                                  click: function ($event) {
                                    col.handle
                                      ? col.handle(col.value)
                                      : function () {}
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      col.formatter
                                        ? col.formatter()
                                        : _vm.orderInfo[col.value]
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ])
                }),
                1
              )
            : _vm._e(),
          _vm.activeName === "4"
            ? _c("cardCommonConfig", {
                attrs: { trendParams: _vm.trendParams },
              })
            : _vm._e(),
          _vm.activeName === "2"
            ? [
                _c(
                  "el-card",
                  { staticClass: "card__style", attrs: { shadow: "never" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "card_header",
                        attrs: { slot: "header" },
                        slot: "header",
                      },
                      [
                        _c("span", { staticClass: "title__style-color" }, [
                          _vm._v("运营日志"),
                        ]),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "success",
                              icon: "el-icon-plus",
                              size: "small",
                            },
                            on: { click: _vm.openOperateDialog },
                          },
                          [_vm._v(" 添加日志 ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          border: "",
                          "header-cell-style": {
                            background: "#F1F1F1",
                            color: "#333333",
                          },
                          data: _vm.operateLogList,
                          "tooltip-effect": "dark",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "created_at",
                            label: "操作时间",
                            align: "left",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "text",
                            label: "操作信息",
                            align: "left",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("div", {
                                      domProps: {
                                        innerHTML: _vm._s(scope.row.text),
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3719080649
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "operation_name",
                            label: "操作人",
                            align: "left",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.operateLogList.length > 0
                      ? _c("el-pagination", {
                          staticStyle: {
                            "text-align": "right",
                            "margin-top": "15px",
                          },
                          attrs: {
                            background: "",
                            layout: "total, prev, pager, next, jumper",
                            total: _vm.operateLogPages.totalCount,
                            "page-size": _vm.operateLogPages.page_size,
                            "current-page": _vm.operateLogPages.page,
                          },
                          on: { "current-change": _vm.onChangeOperateLogPage },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "el-card",
                  {
                    staticClass: "card__style handle_log",
                    attrs: { shadow: "never" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "card_header",
                        attrs: { slot: "header" },
                        slot: "header",
                      },
                      [
                        _c("span", { staticClass: "title__style-color" }, [
                          _vm._v("操作日志"),
                        ]),
                      ]
                    ),
                    _c("log-table-data", {
                      attrs: { "order-log-list": _vm.orderLogList },
                    }),
                    _vm.orderLogList.length > 0
                      ? _c("el-pagination", {
                          staticStyle: {
                            "text-align": "right",
                            "margin-top": "15px",
                          },
                          attrs: {
                            background: "",
                            layout: "total, prev, pager, next, jumper",
                            total: _vm.logDataPages.totalCount,
                            "current-page": _vm.logDataPages.currentPage,
                          },
                          on: { "current-change": _vm.logDataPage },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.activeName === "3"
            ? _c("customer-set", {
                attrs: {
                  module: "plat_service_custom",
                  "customer-data": _vm.orderInfo,
                },
              })
            : _vm._e(),
          _vm.activeName == "9"
            ? [
                !_vm.cardRuleList.length
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-bottom": "10px",
                          "font-size": "13px",
                        },
                      },
                      [
                        _vm.orderType == 1
                          ? _c("span", [
                              _vm._v("订单售卡激活已关闭，没有可审批的项"),
                            ])
                          : _c("span", [
                              _vm._v("渠道售卡激活已关闭，没有可审批的项"),
                            ]),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "el-table",
                  {
                    attrs: {
                      "header-cell-style": {
                        background: "#F1F1F1",
                        color: "#333333",
                        borderColor: "white",
                      },
                      border: "",
                      data: _vm.cardRuleList,
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "sort", label: "序号", width: "70" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  {
                                    style: {
                                      color:
                                        scope.row.trigger_audit == 1
                                          ? "red"
                                          : "",
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(scope.$index + 1) + " ")]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3747535615
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "group", label: "分组", width: "100" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  {
                                    style: {
                                      color:
                                        scope.row.trigger_audit == 1
                                          ? "red"
                                          : "",
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(scope.row.group) + " ")]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3634542756
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "address", label: "检查清单" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("div", {
                                  style: {
                                    color:
                                      scope.row.trigger_audit == 1 ? "red" : "",
                                  },
                                  domProps: {
                                    innerHTML: _vm._s(scope.row.checkOrder),
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3935327056
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "result_str", label: "检查结果" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  {
                                    style: {
                                      color:
                                        scope.row.trigger_audit == 1
                                          ? "red"
                                          : "",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(scope.row.result_str) + " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3638069848
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "address",
                        width: "80",
                        align: "center",
                        label: "触发审核项",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.trigger_audit == 1
                                  ? _c("img", {
                                      staticStyle: {
                                        "vertical-align": "middle",
                                        "margin-right": "2px",
                                      },
                                      attrs: {
                                        width: "18",
                                        src: require("@/assets/icon_alarm.png"),
                                        alt: "",
                                        srcset: "",
                                      },
                                    })
                                  : _vm._e(),
                                scope.row.trigger_audit == 2
                                  ? _c("img", {
                                      staticStyle: {
                                        "vertical-align": "middle",
                                        "margin-right": "2px",
                                      },
                                      attrs: {
                                        width: "18",
                                        src: require("@/assets/icon_bulb.png"),
                                        alt: "",
                                        srcset: "",
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2400190525
                      ),
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeName === "1",
              expression: "activeName === '1'",
            },
          ],
        },
        [
          _c(
            "el-card",
            {
              staticClass: "gross-card",
              staticStyle: { "margin-top": "10px" },
            },
            [
              _c(
                "div",
                { staticClass: "top-btn" },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("订单金额：")]),
                  _c(
                    "el-radio-group",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.getOrderTrend("update_gross")
                        },
                      },
                      model: {
                        value: _vm.gross_profit_type,
                        callback: function ($$v) {
                          _vm.gross_profit_type = $$v
                        },
                        expression: "gross_profit_type",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "2" } }, [
                        _vm._v("按已售金额"),
                      ]),
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("按实收"),
                      ]),
                      _c("el-radio", { attrs: { label: "0" } }, [
                        _vm._v("按应收"),
                      ]),
                      _c("el-radio", { attrs: { label: "3" } }, [
                        _vm._v("按激活金额"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tabs",
                {
                  model: {
                    value: _vm.grossName,
                    callback: function ($$v) {
                      _vm.grossName = $$v
                    },
                    expression: "grossName",
                  },
                },
                [
                  _c("el-tab-pane", {
                    attrs: { label: "订单留存毛利", name: "1" },
                  }),
                ],
                1
              ),
              _c(
                "el-form",
                { staticClass: "form", attrs: { inline: "", size: "small" } },
                _vm._l(_vm.grossList, function (row, rowIndex) {
                  return _c(
                    "el-row",
                    { key: rowIndex, attrs: { gutter: 20 } },
                    _vm._l(row, function (col, colIndex) {
                      return _c(
                        "el-col",
                        { key: colIndex, attrs: { span: 4 } },
                        [
                          _c("el-form-item", { attrs: { label: col.label } }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  col.formatter
                                    ? col.formatter()
                                    : _vm.grossInfo[col.value]
                                ) +
                                " "
                            ),
                          ]),
                        ],
                        1
                      )
                    }),
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-card",
            { staticClass: "tab-card", staticStyle: { "margin-top": "10px" } },
            [
              _c(
                "el-tabs",
                {
                  on: { "tab-click": _vm.changeTab },
                  model: {
                    value: _vm.activeNameChart,
                    callback: function ($$v) {
                      _vm.activeNameChart = $$v
                    },
                    expression: "activeNameChart",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "消费分类统计", name: "1" } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("div", {
                                ref: "datascren_order",
                                staticStyle: { width: "100%", height: "350px" },
                                attrs: { id: "datascren_order" },
                              }),
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    border: "",
                                    "header-cell-style": {
                                      background: "#F1F1F1",
                                      color: "#333333",
                                    },
                                    data: _vm.orderTypeList,
                                    "tooltip-effect": "dark",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "商城订单类型",
                                      prop: "name",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "消费点数",
                                      prop: "amount",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "消费占比",
                                      prop: "occupancy",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row.occupancy + "%"
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "成本率",
                                      prop: "cost_occupancy",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row.cost_occupancy + "%"
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("div", {
                                ref: "datascren_business",
                                staticStyle: { width: "100%", height: "350px" },
                                attrs: { id: "datascren_business" },
                              }),
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    border: "",
                                    "header-cell-style": {
                                      background: "#F1F1F1",
                                      color: "#333333",
                                    },
                                    data: _vm.businessTypeList,
                                    "tooltip-effect": "dark",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: { label: "业务类型", prop: "name" },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "消费点数",
                                      prop: "amount",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "消费占比",
                                      prop: "occupancy",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row.occupancy + "%"
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "成本率",
                                      prop: "cost_occupancy",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row.cost_occupancy + "%"
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: "操作" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            scope.row.name === "总计"
                                              ? _c(
                                                  "el-link",
                                                  {
                                                    attrs: { type: "primary" },
                                                    on: {
                                                      click: _vm.goPlateDetail,
                                                    },
                                                  },
                                                  [_vm._v("明细")]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("div", {
                                ref: "datascren_consume",
                                staticStyle: { width: "100%", height: "350px" },
                                attrs: { id: "datascren_consume" },
                              }),
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    border: "",
                                    "header-cell-style": {
                                      background: "#F1F1F1",
                                      color: "#333333",
                                    },
                                    data: _vm.consumeScenarioList,
                                    "tooltip-effect": "dark",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: { label: "消费场景", prop: "name" },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "消费点数",
                                      prop: "amount",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "消费占比",
                                      prop: "occupancy",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row.occupancy + "%"
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "成本率",
                                      prop: "cost_occupancy",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row.cost_occupancy + "%"
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "业务类型明细", name: "6" } },
                    [
                      _c(
                        "el-row",
                        {
                          staticStyle: { "margin-top": "20px" },
                          attrs: { gutter: 20 },
                        },
                        [
                          _vm.plateData1.length ||
                          _vm.plateData2.length ||
                          _vm.plateData3.length ||
                          _vm.plateData4.length
                            ? [
                                _vm.plateData1.length > 0
                                  ? _c(
                                      "el-col",
                                      { attrs: { span: 12 } },
                                      [
                                        _c("div", {
                                          ref: "datascren_onlineShop",
                                          staticStyle: {
                                            width: "100%",
                                            height: "350px",
                                          },
                                          attrs: { id: "datascren_onlineShop" },
                                        }),
                                        _c(
                                          "el-table",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              border: "",
                                              "header-cell-style": {
                                                background: "#F1F1F1",
                                                color: "#333333",
                                              },
                                              data: _vm.plateData1,
                                              "tooltip-effect": "dark",
                                            },
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: { label: "订单类型" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              scope.row
                                                                .order_type_name ||
                                                                scope.row
                                                                  .order_plate_type_name
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                4269347854
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "消费点数",
                                                prop: "amount",
                                              },
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "消费占比",
                                                prop: "occupancy",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              scope.row
                                                                .occupancy + "%"
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                4035996204
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "成本率",
                                                prop: "cost_occupancy",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              scope.row
                                                                .cost_occupancy +
                                                                "%"
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                4221060248
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.plateData2.length > 0
                                  ? _c(
                                      "el-col",
                                      { attrs: { span: 12 } },
                                      [
                                        _c("div", {
                                          ref: "datascren_media",
                                          staticStyle: {
                                            width: "100%",
                                            height: "350px",
                                          },
                                          attrs: { id: "datascren_media" },
                                        }),
                                        _c(
                                          "el-table",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              border: "",
                                              "header-cell-style": {
                                                background: "#F1F1F1",
                                                color: "#333333",
                                              },
                                              data: _vm.plateData2,
                                              "tooltip-effect": "dark",
                                            },
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: { label: "订单类型" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              scope.row
                                                                .order_type_name ||
                                                                scope.row
                                                                  .order_plate_type_name
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                4269347854
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "菜单名称",
                                                prop: "category_name",
                                              },
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "消费点数",
                                                prop: "amount",
                                              },
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "消费占比",
                                                prop: "occupancy",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              scope.row
                                                                .occupancy + "%"
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                4035996204
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "成本率",
                                                prop: "cost_occupancy",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              scope.row
                                                                .cost_occupancy +
                                                                "%"
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                4221060248
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.plateData3.length > 0
                                  ? _c(
                                      "el-col",
                                      { attrs: { span: 12 } },
                                      [
                                        _c("div", {
                                          ref: "datascren_birthday",
                                          staticStyle: {
                                            width: "100%",
                                            height: "350px",
                                          },
                                          attrs: { id: "datascren_birthday" },
                                        }),
                                        _c(
                                          "el-table",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              border: "",
                                              "header-cell-style": {
                                                background: "#F1F1F1",
                                                color: "#333333",
                                              },
                                              data: _vm.plateData3,
                                              "tooltip-effect": "dark",
                                            },
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: { label: "订单类型" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              scope.row
                                                                .order_type_name ||
                                                                scope.row
                                                                  .order_plate_type_name
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                4269347854
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "消费点数",
                                                prop: "amount",
                                              },
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "消费占比",
                                                prop: "occupancy",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              scope.row
                                                                .occupancy + "%"
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                4035996204
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "成本率",
                                                prop: "cost_occupancy",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              scope.row
                                                                .cost_occupancy +
                                                                "%"
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                4221060248
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.plateData4.length > 0
                                  ? _c(
                                      "el-col",
                                      { attrs: { span: 12 } },
                                      [
                                        _c("div", {
                                          ref: "datascren_third-party_supermarket",
                                          staticStyle: {
                                            width: "100%",
                                            height: "350px",
                                          },
                                          attrs: {
                                            id: "datascren_third-party_supermarket",
                                          },
                                        }),
                                        _c(
                                          "el-table",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              border: "",
                                              "header-cell-style": {
                                                background: "#F1F1F1",
                                                color: "#333333",
                                              },
                                              data: _vm.plateData4,
                                              "tooltip-effect": "dark",
                                            },
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: { label: "订单类型" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              scope.row
                                                                .order_type_name ||
                                                                scope.row
                                                                  .order_plate_type_name
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                4269347854
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "品牌",
                                                prop: "brand_name",
                                              },
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "消费点数",
                                                prop: "amount",
                                              },
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "消费占比",
                                                prop: "occupancy",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              scope.row
                                                                .occupancy + "%"
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                4035996204
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "成本率",
                                                prop: "cost_occupancy",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              scope.row
                                                                .cost_occupancy +
                                                                "%"
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                4221060248
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            : _c("el-col", { attrs: { span: 24 } }, [
                                _c("div", { staticClass: "no-data-text" }, [
                                  _vm._v("暂无数据"),
                                ]),
                              ]),
                        ],
                        2
                      ),
                      _vm.pageDesc
                        ? _c("div", {
                            staticClass: "page-desc",
                            domProps: { innerHTML: _vm._s(_vm.pageDesc) },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "商城菜单统计", name: "4" } },
                    [
                      _c("div", {
                        ref: "datascren_category_cost",
                        staticStyle: { width: "100%", height: "350px" },
                        attrs: { id: "datascren_category_cost" },
                      }),
                      ["platformReport", "abnormalOrderMonitor"].includes(
                        _vm.entry
                      )
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "flex-end",
                                margin: "10px 0",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "mini" },
                                  on: { click: _vm.onClickCategoryExport },
                                },
                                [_vm._v("导出")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            border: "",
                            "header-cell-style": {
                              background: "#F1F1F1",
                              color: "#333333",
                            },
                            data: _vm.categoryCostList,
                            "row-style": function (ref) {
                              var row = ref.row

                              return row.category_name === "总计"
                                ? { fontWeight: "bold", color: "#000" }
                                : {}
                            },
                            "tooltip-effect": "dark",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "菜单名称（ID）",
                              prop: "category_name",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          placement: "top",
                                          disabled:
                                            scope.row.category_name === "总计",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                "别名：" +
                                                  _vm._s(scope.row.alias)
                                              ),
                                            ]),
                                            _c("div", [
                                              _vm._v(
                                                "备注：" +
                                                  _vm._s(scope.row.note)
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(scope.row.category_name)
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "别名", prop: "alias" },
                          }),
                          _c("el-table-column", {
                            attrs: { label: "订单类型", prop: "name" },
                          }),
                          [
                            "platformReport",
                            "abnormalOrderMonitor",
                            "orderListDetail",
                          ].includes(_vm.entry)
                            ? _c(
                                "el-table-column",
                                { attrs: { prop: "order_business_type_name" } },
                                [
                                  _c("template", { slot: "header" }, [
                                    _c("span", [_vm._v("业务类型")]),
                                  ]),
                                ],
                                2
                              )
                            : _vm._e(),
                          _c(
                            "el-table-column",
                            { attrs: { prop: "amount" } },
                            [
                              _c("template", { slot: "header" }, [
                                _c(
                                  "span",
                                  { staticClass: "header-field-container" },
                                  [
                                    _c("span", [_vm._v("消费点数")]),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          content:
                                            "订单消费点数=卡消费点数-退回卡点数",
                                          placement: "top",
                                          "popper-class": "large-tooltip",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-warning-outline header-info-icon",
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            2
                          ),
                          _c(
                            "el-table-column",
                            {
                              attrs: { prop: "occupancy" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(scope.row.occupancy + "%") +
                                          " "
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [
                              _c("template", { slot: "header" }, [
                                _c(
                                  "span",
                                  { staticClass: "header-field-container" },
                                  [
                                    _c("span", [_vm._v("消费占比")]),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          content:
                                            "当前消费点数 / 总计消费点数 *100%",
                                          placement: "top",
                                          "popper-class": "large-tooltip",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-warning-outline header-info-icon",
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            2
                          ),
                          _c(
                            "el-table-column",
                            { attrs: { prop: "actual_cost_amount_a0" } },
                            [
                              _c("template", { slot: "header" }, [
                                _c(
                                  "span",
                                  { staticClass: "header-field-container" },
                                  [
                                    _c("span", [_vm._v("成本")]),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          content: "卡实际分摊真实成本价A0",
                                          placement: "top",
                                          "popper-class": "large-tooltip",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-warning-outline header-info-icon",
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            2
                          ),
                          _c(
                            "el-table-column",
                            {
                              attrs: { prop: "cost_occupancy" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            scope.row.cost_occupancy + "%"
                                          ) +
                                          " "
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [
                              _c("template", { slot: "header" }, [
                                _c(
                                  "span",
                                  { staticClass: "header-field-container" },
                                  [
                                    _c("span", [_vm._v("成本率")]),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          content:
                                            "成本 / 卡实际分摊抵扣金额 *100%",
                                          placement: "top",
                                          "popper-class": "large-tooltip",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-warning-outline header-info-icon",
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            2
                          ),
                          [
                            "platformReport",
                            "abnormalOrderMonitor",
                            "orderListDetail",
                          ].includes(_vm.entry)
                            ? _c("el-table-column", {
                                attrs: {
                                  label: "操作",
                                  width: "70px",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var row = ref.row
                                        return [
                                          row.category_name !== "总计"
                                            ? _c(
                                                "el-link",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    underline: false,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onClickMenuDetail(
                                                        row
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("明细")]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2776766996
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-top": "10px",
                            "text-align": "right",
                          },
                        },
                        [
                          _c("el-pagination", {
                            attrs: {
                              background: "",
                              layout: "total, prev, pager, next, jumper",
                              "current-page": _vm.categoryCostPaging.page,
                              "page-size": _vm.categoryCostPaging.pagesize,
                              total: _vm.categoryCostPaging.totalCount,
                            },
                            on: {
                              "current-change": _vm.changeCategoryCostPage,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "订单消费趋势", name: "2" } },
                    [
                      _vm.costTypeList.length
                        ? _c(
                            "div",
                            { staticStyle: { "margin-bottom": "10px" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  attrs: { size: "small" },
                                  on: { change: _vm.getOrderTrend },
                                  model: {
                                    value: _vm.cost_order_type,
                                    callback: function ($$v) {
                                      _vm.cost_order_type = $$v
                                    },
                                    expression: "cost_order_type",
                                  },
                                },
                                _vm._l(_vm.costTypeList, function (item) {
                                  return _c(
                                    "el-radio-button",
                                    {
                                      key: item.type,
                                      attrs: { label: item.type },
                                    },
                                    [_vm._v(" " + _vm._s(item.name) + " ")]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("div", {
                        ref: "datascren",
                        staticStyle: { width: "100%", height: "250px" },
                        attrs: { id: "datascren" },
                      }),
                      _c(
                        "div",
                        { staticStyle: { float: "right", margin: "10px 0" } },
                        [
                          _vm.entry === "abnormalOrderMonitor" ||
                          _vm.$hasBtnRoles("/count/order-consume-trend/export")
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "mini" },
                                  on: { click: _vm.downFile },
                                },
                                [_vm._v("导出")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            border: "",
                            "header-cell-style": {
                              background: "#F1F1F1",
                              color: "#333333",
                            },
                            data: _vm.list,
                            "tooltip-effect": "dark",
                          },
                        },
                        [
                          _c("el-table-column", {
                            key: "stat_date",
                            attrs: {
                              label: "日期",
                              prop: "stat_date",
                              align: "left",
                              width: "100",
                            },
                          }),
                          _c("el-table-column", {
                            key: "day",
                            attrs: {
                              label: "天数",
                              prop: "day",
                              align: "left",
                              "min-width": "50",
                            },
                          }),
                          _vm.order_type_cn === ""
                            ? _c("el-table-column", {
                                key: "total_amount",
                                attrs: {
                                  label: "售卡点数",
                                  prop: "total_amount",
                                  align: "left",
                                  "min-width": "100",
                                },
                              })
                            : _vm._e(),
                          _c("el-table-column", {
                            key: "consume_points",
                            attrs: {
                              label:
                                "当日消费点数" +
                                (_vm.order_type_cn
                                  ? "(" + _vm.order_type_cn + ")"
                                  : ""),
                              prop: "consume_points",
                              align: "left",
                              "min-width": "100",
                            },
                          }),
                          _c("el-table-column", {
                            key: "cumulative_consume_amount",
                            attrs: {
                              label:
                                "累计消费点数" +
                                (_vm.order_type_cn
                                  ? "(" + _vm.order_type_cn + ")"
                                  : ""),
                              prop: "cumulative_consume_amount",
                              align: "left",
                              "min-width": "100",
                            },
                          }),
                          _c("el-table-column", {
                            key: "consume_ratio",
                            attrs: {
                              label:
                                "" +
                                (_vm.order_type_cn
                                  ? "" + _vm.new_legend[0]
                                  : "当日消费占比"),
                              prop: "consume_ratio",
                              align: "left",
                              "min-width": "100",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.consume_ratio) +
                                        "% "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            key: "cumulative_consume_ratio",
                            attrs: {
                              label:
                                "" +
                                (_vm.order_type_cn
                                  ? "" + _vm.new_legend[1]
                                  : "累计消费占比"),
                              prop: "cumulative_consume_ratio",
                              align: "left",
                              "min-width": "100",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.cumulative_consume_ratio >
                                    scope.row.alarm_number
                                      ? _c(
                                          "div",
                                          { staticStyle: { color: "#F56C6C" } },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row
                                                    .cumulative_consume_ratio
                                                ) +
                                                "% 累计消费异常 "
                                            ),
                                          ]
                                        )
                                      : _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.cumulative_consume_ratio
                                            ) + "%"
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm.order_type_cn === ""
                            ? _c("el-table-column", {
                                key: "alarm_number",
                                attrs: {
                                  label: "累计消费预警值",
                                  prop: "alarm_number",
                                  align: "left",
                                  "min-width": "100",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(scope.row.alarm_number) +
                                              _vm._s(
                                                scope.row.alarm_number + "" ===
                                                  ""
                                                  ? ""
                                                  : "%"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1185589037
                                ),
                              })
                            : _vm._e(),
                          _vm.order_type_cn === ""
                            ? _c("el-table-column", {
                                key: "logs",
                                attrs: {
                                  label: "订单日志",
                                  "min-width": "200",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return Array.isArray(scope.row.logs)
                                          ? _vm._l(
                                              scope.row.logs,
                                              function (log, index) {
                                                return _c(
                                                  "div",
                                                  { key: index },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          log.operation_name ||
                                                            ""
                                                        ) +
                                                        " " +
                                                        _vm._s(log.created_at) +
                                                        " " +
                                                        _vm._s(log.text) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              }
                                            )
                                          : undefined
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "tips" }, [
                        _c("div", [_vm._v("备注：")]),
                        _c("div", [_vm._v("日期：从订单的首笔消费日期记起。")]),
                        _c("div", [_vm._v("天数：离订单首笔消费日期的天数。")]),
                        _c("div", [
                          _vm._v(
                            " 售卡点数：本页面中每日统计的订单售卡点数，为所在日期订单留存点数和截止到所在日期订单累计消费点数之和。 "
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            "当日消费点数：为所在日期订单发生的消费点数。"
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            "累计消费点数：截止到所在日期订单累计消费点数。"
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            "当日消费占比：=（当日消费点数 / 售卡点数）*100%。"
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            "累计消费占比：=（累计消费点数 / 售卡点数）*100%。"
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "订单成本率趋势", name: "3" } },
                    [
                      _c(
                        "el-form",
                        { attrs: { model: _vm.searchForm, inline: "" } },
                        [
                          _vm.rateTypeList.length
                            ? _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { size: "small" },
                                      on: {
                                        change: function ($event) {
                                          return _vm.changePage(1)
                                        },
                                      },
                                      model: {
                                        value: _vm.searchForm.rate_order_type,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.searchForm,
                                            "rate_order_type",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "searchForm.rate_order_type",
                                      },
                                    },
                                    _vm._l(_vm.rateTypeList, function (item) {
                                      return _c(
                                        "el-radio-button",
                                        {
                                          key: item.type,
                                          attrs: { label: item.type },
                                        },
                                        [_vm._v(" " + _vm._s(item.name) + " ")]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "daterange",
                                  "value-format": "yyyy-MM-dd",
                                  "range-separator": "至",
                                  "start-placeholder": "开始日期",
                                  "end-placeholder": "结束日期",
                                  size: "small",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.changePage(1)
                                  },
                                },
                                model: {
                                  value: _vm.searchForm.date_time,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchForm, "date_time", $$v)
                                  },
                                  expression: "searchForm.date_time",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("div", {
                        ref: "costRate",
                        staticStyle: { width: "100%", height: "250px" },
                        attrs: { id: "costRate" },
                      }),
                      _vm.entry === "platformReport"
                        ? _c(
                            "div",
                            {
                              staticStyle: { float: "right", margin: "10px 0" },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "mini" },
                                  on: { click: _vm.downFileCost },
                                },
                                [_vm._v("导出")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            border: "",
                            "header-cell-style": {
                              background: "#F1F1F1",
                              color: "#333333",
                            },
                            data: _vm.costRateList,
                            "tooltip-effect": "dark",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "日期",
                              prop: "date",
                              align: "left",
                              width: "100",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "当日抵扣金额",
                              prop: "deduction_amount",
                              align: "left",
                            },
                          }),
                          _vm.searchForm.rate_order_type !== ""
                            ? _c("el-table-column", {
                                attrs: {
                                  label: "消费占比",
                                  prop: "consume_rate",
                                  align: "left",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(scope.row.consume_rate) +
                                              _vm._s(
                                                scope.row.consume_rate
                                                  ? "%"
                                                  : ""
                                              ) +
                                              " "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3983688987
                                ),
                              })
                            : _vm._e(),
                          _c("el-table-column", {
                            attrs: {
                              label: "当日成本",
                              prop: "cost_price",
                              align: "left",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "当日成本率",
                              prop: "cost_price_rate",
                              align: "left",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.cost_price_rate) +
                                        _vm._s(
                                          scope.row.cost_price_rate ? "%" : ""
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "累计抵扣金额",
                              prop: "cumulative_deduction_amount",
                              align: "left",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "累计成本",
                              prop: "cumulative_cost_price",
                              align: "left",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "累计成本率",
                              prop: "cumulative_price_rate",
                              align: "left",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          scope.row.cumulative_price_rate
                                        ) +
                                        _vm._s(
                                          scope.row.cumulative_price_rate
                                            ? "%"
                                            : ""
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "订单日志" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return Array.isArray(scope.row.logs)
                                      ? _vm._l(
                                          scope.row.logs,
                                          function (log, index) {
                                            return _c("div", { key: index }, [
                                              _vm._v(
                                                " " +
                                                  _vm._s(log.created_at) +
                                                  " " +
                                                  _vm._s(log.text) +
                                                  " "
                                              ),
                                            ])
                                          }
                                        )
                                      : undefined
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-top": "10px",
                            "text-align": "right",
                          },
                        },
                        [
                          _c("el-pagination", {
                            attrs: {
                              background: "",
                              layout: "total, prev, pager, next, jumper",
                              "current-page": _vm.paging.page,
                              "page-size": _vm.paging.page_size,
                              total: _vm.paging.totalCount,
                            },
                            on: { "current-change": _vm.changePage },
                          }),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "tips" }, [
                        _c("div", [_vm._v("备注：")]),
                        _c("div", [_vm._v("日期：从订单的首笔消费日期记起。")]),
                        _c("div", [
                          _vm._v(
                            " 当日抵扣金额：取 [订单消费明细] 中的“卡实际分摊抵扣金额”（含分摊微信支付金额）； "
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            " 当日成本：取 [订单消费明细] 中的“卡实际分摊真实成本A0”； "
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            " 当日成本率：=当日成本/当日抵扣金额 *100%； "
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            "累计抵扣金额：截止到所在日期，累计抵扣金额；"
                          ),
                        ]),
                        _c("div", [
                          _vm._v("累计成本：截止到所在日期，累计成本；"),
                        ]),
                        _c("div", [
                          _vm._v("累计成本率：=累计成本/累计抵扣金额 *100%。"),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "售后数据", name: "5" } },
                    [
                      _c("div", { staticClass: "evaluate-gauge-container" }, [
                        _c("div", { staticClass: "evaluate-gauge-wrap" }, [
                          _c(
                            "div",
                            {
                              staticClass: "wrap",
                              style: {
                                "--rotate": _vm.selectData.avg_satisfied_rate,
                              },
                            },
                            [
                              _c("div", { staticClass: "twenty_five" }, [
                                _vm._v("25%"),
                              ]),
                              _c("div", { staticClass: "fifty" }, [
                                _vm._v("50%"),
                              ]),
                              _c("div", { staticClass: "seventy_five" }, [
                                _vm._v("75%"),
                              ]),
                              _c("div", { staticClass: "circle_wrap" }),
                              _c("div", { staticClass: "pointer" }),
                            ]
                          ),
                          _c("div", { staticClass: "text" }, [
                            _vm._v(
                              " 订单满意度图：" +
                                _vm._s(
                                  _vm.order_evaluate.avg_satisfied_rate || 0
                                ) +
                                "% "
                            ),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "evaluate-title" }, [
                        _vm._v("订单评价满意度明细"),
                      ]),
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            border: "",
                            "header-cell-style": {
                              background: "#F1F1F1",
                              color: "#333333",
                            },
                            data: _vm.evaluateList,
                            "tooltip-effect": "dark",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "发出调查数",
                              prop: "send_total",
                              align: "left",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "参与调查数",
                              width: "160",
                              prop: "participation_num",
                              align: "left",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "参与率",
                              prop: "participation_rate",
                              align: "left",
                              formatter: function (row) {
                                return row.participation_rate
                                  ? row.participation_rate
                                  : ""
                              },
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "无效评价数",
                              prop: "untreated_num",
                              align: "left",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "满意数",
                              prop: "satisfied_num",
                              align: "left",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "调查满意度",
                              prop: "survey_satisfied_rate",
                              align: "left",
                              formatter: function (row) {
                                return row.survey_satisfied_rate
                                  ? row.survey_satisfied_rate
                                  : ""
                              },
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "综合满意度",
                              prop: "overall_satisfied_rate",
                              formatter: function (row) {
                                return row.overall_satisfied_rate
                                  ? row.overall_satisfied_rate
                                  : ""
                              },
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "不满意数",
                              prop: "not_satisfied_num",
                              align: "left",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "一般数",
                              prop: "generally_num",
                              align: "left",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "操作",
                              fixed: "right",
                              width: "90px",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text", size: "mini" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onOpenEvaluateDetail(
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("查看明细")]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  [
                    "platformReport",
                    "abnormalOrderMonitor",
                    "orderListDetail",
                  ].includes(_vm.entry)
                    ? _c(
                        "el-tab-pane",
                        { attrs: { label: "下单省份统计", name: "8" } },
                        [
                          _c("provinceStatistics", {
                            ref: "provinceStatistics",
                            attrs: {
                              "order-id": _vm.orderId,
                              entry: _vm.entry,
                            },
                            on: { "jump-city": _vm.onJumpCityStatistics },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  [
                    "platformReport",
                    "abnormalOrderMonitor",
                    "orderListDetail",
                  ].includes(_vm.entry)
                    ? _c(
                        "el-tab-pane",
                        { attrs: { label: "下单城市统计", name: "7" } },
                        [
                          _c("cityStatistics", {
                            ref: "cityStatistics",
                            attrs: {
                              "order-id": _vm.orderId,
                              entry: _vm.entry,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.operateDialog,
            "append-to-body": "",
            title: "添加运营日志",
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.operateDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "operateForm", attrs: { model: _vm.operateForm } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "text",
                    rules: [{ required: true, message: "请输入日志内容" }],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: 3, placeholder: "请输入" },
                    model: {
                      value: _vm.operateForm.text,
                      callback: function ($$v) {
                        _vm.$set(_vm.operateForm, "text", $$v)
                      },
                      expression: "operateForm.text",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "medium", plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.operateDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "20px" },
                  attrs: { type: "primary", size: "medium" },
                  on: { click: _vm.addOperateLog },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("evaluateDetailDrawer", {
        attrs: {
          drawerVisible: _vm.evaluateDetailVisible,
          orderId: _vm.orderId,
        },
        on: { close: _vm.onCloseEvaluateDetail },
      }),
      _c("menuDetailDrawer", {
        attrs: {
          drawerVisible: _vm.menuDetailVisible,
          entry: _vm.entry,
          originParams: _vm.menuDetailParams,
        },
        on: { close: _vm.onCloseMenuDetail },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }